export const DEFAULT_CASHBACK_PERCENTAGE = 30

export enum CashBackTransactionStatusEnums {
  PENDING = 1,
  FAILED = -1,
  IN_BATCH = 2,
  REVIEWING = 3,
  SUCCESS = 10,
}
